"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oauthMiddleware = void 0;

var _actions = require("./oauth/actions");

var _constants = require("./oauth/constants");

var _utils = require("./permissions/utils");

var _utils2 = require("./openid-configuration/utils");

/**
 * @desc
 * Middleware that initializes resources for OAuth.
 */
var oauthMiddleware = function oauthMiddleware(store) {
  return function (next) {
    return function (action) {
      var type = action.type,
          payload = action.payload;
      var dispatch = store.dispatch;

      if (type === _actions.SET_OAUTH_STATE && payload.state === _constants.oAuthStates.VALID) {
        dispatch((0, _utils.fetchPermissions)());
        dispatch((0, _utils2.fetchOpenidConfiguration)());
      }

      return next(action);
    };
  };
};

exports.oauthMiddleware = oauthMiddleware;
//# sourceMappingURL=oauth-middleware.js.map